import React from 'react';
import Page from '../../layout/Page';
import PromoCodes from './PromoCodes';

const PromoCodesPage = () => (
    <Page title='Promo Codes' icon='mobile'>
        <PromoCodes />
    </Page>
);

export default PromoCodesPage;
